module.exports = __webpack_public_path__ + "img/p61-baiqiang-2015.51032f13.jpg";